import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useStreamAuth } from '../../hooks/useStreamAuth';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children, requiredRole = null, fallback = null }) => {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const { hasRole } = useStreamAuth();

  // Show loading spinner while Auth0 is determining authentication state
  if (isLoading) {
    return <LoadingSpinner />;
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    // Store the current location to redirect back after login
    const returnTo = window.location.pathname + window.location.search;
    loginWithRedirect({
      appState: { returnTo },
    });
    return <LoadingSpinner message="Redirecting to login..." />;
  }

  // Check for required role if specified
  if (requiredRole && !hasRole(requiredRole)) {
    return (
      fallback || (
        <div className="flex items-center justify-center min-h-screen bg-gray-900">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-white mb-4">Access Denied</h2>
            <p className="text-gray-300 mb-6">You don't have permission to access this content.</p>
            <p className="text-sm text-gray-400">Required role: {requiredRole}</p>
          </div>
        </div>
      )
    );
  }

  // User is authenticated and has required permissions
  return children;
};

export default ProtectedRoute;
